module.exports = __webpack_public_path__ + "img/bag_bw_thumb.6db139a6.jpg";